<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import Labels from 'shared/components/label/Labels.svelte';
    import {getLocalization, getSanitize} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';

    const localize = getLocalization();
    const sanitizeHtml = getSanitize();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
</script>

<div class="record-heading-container">
    <!-- Title -->
    <h1 id="detail-main-name" class="title">{model.record.name}</h1>

    <!-- Subtitle -->
    {#if model.record.subtitle && model.record.subtitle.length > 0}
        <span id="detail-main-subtitle" class="subtitle">
            <Labels labeleds="{model.record.subtitle}" linkifyUrls="{true}"/>
        </span>
    {/if}

    <!-- Related records -->
    {#each model.relatedRecordItems as relatedRecordItem}
        <div class="related-record">
            <span>{@html sanitizeHtml(relatedRecordItem.field787Value)}</span>

            {#if relatedRecordItem.partValue}
                <span>, {localize(/* @kp-localization commons.part */ 'commons.part')} {@html sanitizeHtml(relatedRecordItem.partValue)}</span>
            {/if}
        </div>
    {/each}

    <!-- Responsibility statement -->
    {#if model.record.responsibilityStatement}
        <div id="detail-main-responsibility" class="responsibility">
            <Labels labeleds="{[model.record.responsibilityStatement]}" linkifyUrls="{true}"/>
        </div>
    {/if}

    <!-- Value of subfield 100 abc -->
    {#if model.sf100abcFieldValue}
        <div id="detail-main-100abc">{@html sanitizeHtml(model.sf100abcFieldValue)}</div>
    {/if}

    <!-- Primary authors -->
    {#if model.record.primaryAuthors && model.record.primaryAuthors.length > 0}
        <div id="detail-main-author" class="main-author">
            <Labels labeleds="{model.record.primaryAuthors}"/>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .title,
    .subtitle {
        margin: 0;
    }

    .subtitle {
        color: gray;
        font-size: @font-size-h3;
    }

    .main-author {
        color: blue;
    }

    .main-author,
    .related-record,
    .responsibility {
        font-size: 1.1em;
        margin-bottom: 10px;
    }

    .main-author {
        margin-bottom: 0;
    }
</style>